import { Button, Table } from "antd";
import { InboundEmail, InboundEmailAttachment } from "../api/models";
import moment from "moment";
import { useState } from "react";
import APIClient from "../api/api";
import EmailDetailModal from "./EmailDetailModal";

export interface Props {
    emails: InboundEmail[];
}

const InboundEmailList = (props: Props) => {
    const [viewEmailId, setViewEmailId] = useState<number>();

    const columns = [
        {
            key: 'sentAt',
            title: 'Received',
            render: (e: InboundEmail) => {
                return moment(e.sentAt).format('LLL');
            }
        },
        {
            key: 'from',
            title: 'From',
            render: (e: InboundEmail) => {
                return e.from;
            }
        },
        {
            key: 'subject',
            title: 'Subject',
            render: (e: InboundEmail) => {
                return e.subject;
            }
        },
        {
            key: 'attachments',
            title: 'Attachments',
            render: (e: InboundEmail) => {
                return (
                    <div>
                        {e.attachments.map((a: InboundEmailAttachment) => (
                            <div key={a.id}>
                                <a target="_new" href={APIClient.getAttachmentDownloadUrl(a)}>{a.filename}</a>
                            </div>
                        ))}
                    </div>
                );
            }
        },
        {
            key: 'content',
            title: 'Content',
            render: (e: InboundEmail) => {
                return (
                    <Button type="primary" onClick={() => setViewEmailId(e.id)}>View</Button>
                )
            }
        }
    ];

    return (
        <div>
            <Table columns={columns} rowKey="id" dataSource={props.emails}>
            </Table>
            {viewEmailId != null && (
                <EmailDetailModal
                    emailId={viewEmailId}
                    onClose={() => setViewEmailId(undefined)}
                />
            )}
        </div>
    )
};
export default InboundEmailList;
